import { render, staticRenderFns } from "./LoopMainCard.vue?vue&type=template&id=6a373681&scoped=true"
import script from "./LoopMainCard.vue?vue&type=script&lang=js"
export * from "./LoopMainCard.vue?vue&type=script&lang=js"
import style0 from "./LoopMainCard.vue?vue&type=style&index=0&id=6a373681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a373681",
  null
  
)

export default component.exports